export const shareItemList = [
    {
        img: require('../images/sharePop/icon-share-wx.png'),
        txt: '微信好友',
        type: 'wxFriend',
    },
    {
        img: require('../images/sharePop/icon-share-pyq.png'),
        txt: '微信朋友圈',
        type: 'wxComment',
    },
    {
        img: require('../images/sharePop/icon-copy.png'),
        txt: '复制链接',
        type: 'copy',
    },
    {
        img: require('../images/sharePop/icon-share-pic.png'),
        txt: '分享图片',
        type: 'picture',
    },
];
